
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getType } from '@/utils/cookies'
@Component({
  name: 'exTotal'
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any
  private sysType: any = ''
  mounted () {
    this.sysType = getType()
  }
}
